import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { BaseButton } from 'iebt-zing-storybook'
import { trans } from 'sharedKernel/i18n'

interface PaginationControlsProps {
  page: number
  totalPages: number
  totalRows: number
  onPrev: () => void
  onNext: () => void
}

export const PaginationControls = ({
  page,
  totalPages,
  totalRows,
  onPrev,
  onNext
}: PaginationControlsProps): JSX.Element => {
  if (totalPages <= 1) return <></>

  return (
    <Row className="mt-3">
      <Col className="d-flex justify-content-center align-items-center gap-2">
        <BaseButton
          variant="primary-invert"
          size="small"
          disabled={page === 1}
          btnContent={trans('Anterior')}
          onClick={onPrev}
        />
        <span className="mx-2">
          {trans('Página')} {page} {trans('de')} {totalPages} ({totalRows} {trans('itens')})
        </span>
        <BaseButton
          variant="primary-invert"
          size="small"
          disabled={page >= totalPages}
          btnContent={trans('Próxima')}
          onClick={onNext}
        />
      </Col>
    </Row>
  )
}